// extracted by mini-css-extract-plugin
module.exports = {"snowWebcams":"styles_snowWebcams__tqL7c","header":"styles_header__1qB_6","title":"styles_title__jmhUO","btn":"styles_btn__cKSlt","wrapperBox":"styles_wrapperBox__aC2t4"};